<span class="btn btn-{{indicatorClass}}"
      title="{{indicatorDescription}}"
      *ngIf="(rateIndexID > 0 && rateIndexList.length > 0) || rateIndexName != ''">{{indicatorAbbrev}}</span>